import Vue from "vue";
import VueRouter from "vue-router";
/* import Home from '@/views/home/homeView.vue' */
import store from "@/store/index.js";

/* import { setDocumentBodyOverflowProperty } from "@/common/util" */

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    /* 	component: Home, */
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/homeView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/account",
    component: () =>
      import(
        /* webpackChunkName: "account" */ "@/views/account/AccountView.vue"
      ),
    children: [
      {
        path: "",
        name: "Account",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "@/views/account/Account.vue"
          ),
      },
      {
        path: "profile",
        name: "Profile",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "@/views/account/Profile.vue"
          ),
      },
      {
        path: "home-profile",
        name: "HomeProfile",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "@/views/account/HomeProfile.vue"
          ),
      },
      {
        path: "reset-password",
        name: "ResetPassword",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "@/views/account/ResetPassword.vue"
          ),
      },
    ],

    meta: { requiresAuth: true },
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: () =>
      import(/* webpackChunkName: "welcome" */ "@/views/Welcome.vue"),
    meta: { requiresAuth: false },
  },
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: () =>
  //     import(/* webpackChunkName: "loginRegister" */ "@/views/Login.vue"),
  //   meta: { requiresAuth: false },
  // },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "loginRegister" */
  //       "@/views/register/RegisterView.vue"
  //     ),
  //   meta: { requiresAuth: false },
  // },
  {
    path: "/surveys/wind-hazard/",
    component: () =>
      import(
        /* webpackChunkName: "surveyWindHazard" */
        "@/views/WindHazard/WindHazardView.vue"
      ),
    children: [
      {
        path: "/",
        name: "WindHazard",
        component: () =>
          import(
            /* webpackChunkName: "surveyWindHazard" */
            "@/views/WindHazard/GettingStarted.vue"
          ),
      },

      {
        path: "survey",
        name: "WindHazardSurvey",
        component: () =>
          import(
            /* webpackChunkName: "surveyWindHazard" */
            "@/views/WindHazard/Survey.vue"
          ),
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: "/surveys/flood-hazard/",
    component: () =>
      import(
        /* webpackChunkName: "surveyFloodHazard" */
        "@/views/FloodHazard/FloodHazardView.vue"
      ),
    children: [
      {
        path: "/",
        name: "FloodHazard",
        component: () =>
          import(
            /* webpackChunkName: "surveyFloodHazard" */
            "@/views/FloodHazard/GettingStarted.vue"
          ),
      },

      {
        path: "survey",
        name: "FloodHazardSurvey",
        component: () =>
          import(
            /* webpackChunkName: "surveyFloodHazard" */
            "@/views/FloodHazard/Survey.vue"
          ),
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: "/surveys/water-shortage-hazard/",
    component: () =>
      import(
        /* webpackChunkName: "surveyWaterHazard" */
        "@/views/WaterHazard/WaterHazardView.vue"
      ),
    children: [
      {
        path: "/",
        name: "WaterHazard",
        component: () =>
          import(
            /* webpackChunkName: "surveyWaterHazard" */
            "@/views/WaterHazard/GettingStarted.vue"
          ),
      },

      {
        path: "survey",
        name: "WaterHazardSurvey",
        component: () =>
          import(
            /* webpackChunkName: "surveyWaterHazard" */
            "@/views/WaterHazard/Survey.vue"
          ),
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: "/summary-assessment",
    name: "summary",
    component: () =>
      import(
        /* webpackChunkName: "summaryAssessment" */ "@/views/Summary/index.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "About" */ "@/views/About.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/competition",
    name: "competition",
    component: () =>
      import(
        /* webpackChunkName: "Submission" */ "@/views/submission/index.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/adaptation-plan",
    name: "adaptationPlan",
    component: () =>
      import(
        /* webpackChunkName: "Adaptation" */ "@/views/adaptationPlan/index.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/calculator",
    name: "energyCalculator",
    component: () =>
      import(
        /* webpackChunkName: "energyCalculator" */ "@/components/EnergyCalculator.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/resource-centre",
    name: "resourceCenter",
    component: () =>
      import(
        /* webpackChunkName: "resources" */ "@/views/resourcecentre/index.vue"
      ),
    meta: { requiresAuth: true },
    children: [
      {
        path: ":id",
        name: "resource",
        component: () =>
          import(
            /* webpackChunkName: "resources" */ "@/views/resourcecentre/resource.vue"
          ),
      },
    ],
  },
  {
    name: "askAnExpert",
    path: "/ask-an-expert",
    component: () =>
      import(
        /* webpackChunkName: "resources" */ "@/views/resourcecentre/askAnExpert.vue"
      ),
  },
  {
    path: "/admin",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/index"),
    children: [
      {
        path: "/",
        name: "admin",
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "@/views/admin/users.vue"
          ),
      },
      {
        path: "users/:id",
        name: "userView",
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "@/components/admin/userView.component.vue"
          ),
      },
    ],
  },
  // {
  //     path: '/flood-hazard',
  //     name: 'FloodHazard',
  //     component: () =>
  //         import ( /* webpackChunkName: "about" */ '@/views/FloodHazard.vue'),
  //     meta: { requiresAuth: true }

  // },
  // {
  //     path: '/water-hazard',
  //     name: 'WaterHazard',
  //     // route level code-splitting
  //     // this generates a separate chunk (WaterHazard.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () =>
  //         import ( /* webpackChunkName: "WaterHazard" */ '@/views/WaterHazard.vue'),

  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  //TODO: Prevent login/register page if user is logged in
  if (
    to.matched.some((m) => m.meta.requiresAuth) &&
    !store.state.User.isLogin
  ) {
    // next()
    // next({ name: "Login" });
  } /* else if (!to.matched.some(m => m.meta.requiresAuth) && store.state.User.isLogin) {
        next({ name: 'Home' })
    } */
  next();

  /*     setDocumentBodyOverflowProperty("auto") */
});

export default router;
